import { render, staticRenderFns } from "./MemberInfo.vue?vue&type=template&id=35de0a7a&scoped=true&"
import script from "./MemberInfo.vue?vue&type=script&lang=js&"
export * from "./MemberInfo.vue?vue&type=script&lang=js&"
import style0 from "./MemberInfo.vue?vue&type=style&index=0&id=35de0a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35de0a7a",
  null
  
)

export default component.exports